import * as ng from 'angular';

export class AcceptFatturaElettronicaPassivaModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$uibModalInstance'
    ];

    private status: any;

    constructor(
        private $scope: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService
    ) {

        this.status = $scope.$parent.$resolve.status;
        $scope.showErrorMessage = false;
        $scope.config = $scope.$parent.$resolve.config;
        $scope.status_details = '';
        $scope.descrizioneType = new RegExp('^[\u0000-\u00FF]{0,255}$');

        $scope.do = (btnId) => {

            if (btnId === 2 && this.status === '') {
                if (($scope.status_details === undefined || $scope.status_details === '') && !$scope.config.accepted) {
                    $scope.showErrorMessage = true;
                    return;
                }
            }
            $scope.showErrorMessage = false;

            let details = {
                'buttonId': btnId,
                'descrizione': $scope.status_details
            };

            $uibModalInstance.close(details);
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/accept-fattura-elettronica-passiva-modal/accept-fattura-elettronica-passiva-modal.ts